// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueTopScholars_venue-top-scholars__veTJk {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_search-scholar-section__r7a0j {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 12px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_search-scholar-section__r7a0j .VenueTopScholars_clear-search-button__coNxN {
  padding: 4px 8px;
  border: 1px solid var(--explore-color);
  border-radius: 50px;
  color: var(--dark-grey);
  background: transparent;
  margin-left: 10px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_search-scholar-section__r7a0j .VenueTopScholars_clear-search-button__coNxN:hover {
  background: var(--explore-color);
  color: white;
  cursor: pointer;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_search-scholar-section__r7a0j .VenueTopScholars_clear-search-button__coNxN:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__tQBJ1 {
  display: flex;
  margin-bottom: 25px;
  border-radius: 8px;
  border: 1px solid var(--accent-color-light);
  box-shadow: 0 0 rgba(0, 0, 0, 0), 0 0 rgba(0, 0, 0, 0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd {
  min-width: 80px;
  min-height: 130px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd .VenueTopScholars_ranking__N\\+zWI {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--accent-color-light);
  font-size: 14px;
  color: var(--light-pink);
  font-weight: bold;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd .VenueTopScholars_ranking--index__BjwwP {
  font-size: 20px;
  color: var(--accent-color-dark);
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__adeuw {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 8px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa {
  display: flex;
  gap: 8px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_avatar__NFUSI {
  aspect-ratio: 1/1;
  height: 70px;
  position: relative;
  border: 1px solid var(--light-grey);
  border-radius: 9999px;
  overflow: hidden;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_avatar__NFUSI .VenueTopScholars_photo__AmZj6 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_avatar__NFUSI .VenueTopScholars_check__pNaqZ {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: -5px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__top__6M011 {
  display: flex;
  justify-content: space-between;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_name__tJZTu {
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_name__tJZTu:hover {
  text-decoration: underline;
  color: var(--blue);
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_score__buqZm {
  display: flex;
  align-items: center;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_inst-name__2zdds {
  font-size: 14px;
  color: var(--grey-text);
  font-weight: 600;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_inst-name__2zdds:hover {
  text-decoration: underline;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_position__Jv09Z {
  font-size: 14px;
  color: var(--dark-grey);
  font-style: italic;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_tags__74-VA {
  margin-bottom: 5px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__GufRs {
  display: flex;
  gap: 12px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item__GA2Zo {
  padding: 4px 8px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  display: flex;
  align-items: center;
  gap: 4px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--icon__zKr4L {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--icon__zKr4L svg {
  width: 16px;
  height: 16px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--icon__zKr4L svg path {
  stroke: var(--accent-color-dark);
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--content__1vWid {
  display: flex;
  align-items: center;
  gap: 4px;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--value__1ROln {
  color: var(--accent-color-dark);
  font-size: 16;
  font-weight: bold;
}
.VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__bottom__uzAo8 .VenueTopScholars_statistics__item--title__L\\+uSU {
  color: var(--dark-grey);
  font-size: 14px;
}
@media only screen and (max-width: 480px) {
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__tQBJ1 {
    border: none;
    border-bottom: 1px solid var(--light-grey);
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 10px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd {
    padding-top: 9px;
    min-width: 40px;
    min-height: 65px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd .VenueTopScholars_ranking__N\\+zWI {
    height: 40px;
    font-size: 10px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__left__OCrsd .VenueTopScholars_ranking--index__BjwwP {
    font-size: 14px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__adeuw {
    padding: 0 0 12px 12px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_avatar__NFUSI {
    min-width: 60px;
    max-width: 60px;
    height: 60px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke {
    gap: 4px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_name__tJZTu {
    font-size: 16px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_score__buqZm {
    font-size: 12px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_score__buqZm svg {
    width: 16px;
    height: 16px;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_score__buqZm span {
    display: none;
  }
  .VenueTopScholars_venue-top-scholars__veTJk .VenueTopScholars_peer__right__top__\\+yxfa .VenueTopScholars_info__kJ9ke .VenueTopScholars_inst-name__2zdds {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/VenueTopScholars/VenueTopScholars.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACE,gBAAA;EACA,sCAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AACN;AACM;EACE,gCAAA;EACA,YAAA;EACA,eAAA;AACR;AAEM;EACE,YAAA;EACA,mBAAA;AAAR;AAKE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,uFAAA;AAHJ;AAKI;EACE,eAAA;EACA,iBAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAHR;AAKQ;EACE,eAAA;EACA,+BAAA;AAHV;AAQI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;AANN;AAQM;EACE,aAAA;EACA,QAAA;AANR;AAQQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,qBAAA;EACA,gBAAA;AANV;AAQU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AANZ;AASU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAPZ;AAWQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATV;AAWU;EACE,aAAA;EACA,8BAAA;AATZ;AAYU;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAVZ;AAYY;EACE,0BAAA;EACA,kBAAA;AAVd;AAcU;EACE,aAAA;EACA,mBAAA;AAZZ;AAeU;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;AAbZ;AAeY;EACE,0BAAA;AAbd;AAiBU;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;AAfZ;AAkBU;EACE,kBAAA;AAhBZ;AAqBM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnBR;AAqBQ;EACE,aAAA;EACA,SAAA;AAnBV;AAqBU;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAnBZ;AAqBY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAnBd;AAqBc;EACE,WAAA;EACA,YAAA;AAnBhB;AAqBgB;EACE,gCAAA;AAnBlB;AAwBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAtBd;AAyBY;EACE,+BAAA;EACA,aAAA;EACA,iBAAA;AAvBd;AA0BY;EACE,uBAAA;EACA,eAAA;AAxBd;AAgCE;EACE;IACE,YAAA;IACA,0CAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA9BJ;EAgCI;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EA9BN;EAgCM;IACE,YAAA;IACA,eAAA;EA9BR;EAgCQ;IACE,eAAA;EA9BV;EAmCI;IACE,sBAAA;EAjCN;EAoCQ;IACE,eAAA;IACA,eAAA;IACA,YAAA;EAlCV;EAqCQ;IACE,QAAA;EAnCV;EAoCU;IACE,eAAA;EAlCZ;EAqCU;IACE,eAAA;EAnCZ;EAqCY;IACE,WAAA;IACA,YAAA;EAnCd;EAqCY;IACE,aAAA;EAnCd;EAuCU;IACE,eAAA;EArCZ;AACF","sourcesContent":[".venue-top-scholars {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  .search-scholar-section {\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .clear-search-button {\n      padding: 4px 8px;\n      border: 1px solid var(--explore-color);\n      border-radius: 50px;\n      color: var(--dark-grey);\n      background: transparent;\n      margin-left: 10px;\n\n      &:hover {\n        background: var(--explore-color);\n        color: white;\n        cursor: pointer;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .peer {\n    display: flex;\n    margin-bottom: 25px;\n    border-radius: 8px;\n    border: 1px solid var(--accent-color-light);\n    box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);\n\n    &__left {\n      min-width: 80px;\n      min-height: 130px;\n\n      .ranking {\n        width: 100%;\n        height: 80px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--accent-color-light);\n        font-size: 14px;\n        color: var(--light-pink);\n        font-weight: bold;\n\n        &--index {\n          font-size: 20px;\n          color: var(--accent-color-dark);\n        }\n      }\n    }\n\n    &__right {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      padding: 24px;\n      gap: 8px;\n\n      &__top {\n        display: flex;\n        gap: 8px;\n\n        .avatar {\n          aspect-ratio: 1/1;\n          height: 70px;\n          position: relative;\n          border: 1px solid var(--light-grey);\n          border-radius: 9999px;\n          overflow: hidden;\n\n          .photo {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n\n          .check {\n            position: absolute;\n            width: 20px;\n            height: 20px;\n            bottom: 0;\n            right: -5px;\n          }\n        }\n\n        .info {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          &__top {\n            display: flex;\n            justify-content: space-between;\n          }\n\n          .name {\n            font-size: 16px;\n            font-weight: 600;\n            cursor: pointer;\n\n            &:hover {\n              text-decoration: underline;\n              color: var(--blue);\n            }\n          }\n\n          .score {\n            display: flex;\n            align-items: center;\n          }\n\n          .inst-name {\n            font-size: 14px;\n            color: var(--grey-text);\n            font-weight: 600;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n\n          .position {\n            font-size: 14px;\n            color: var(--dark-grey);\n            font-style: italic;\n          }\n\n          .tags {\n            margin-bottom: 5px;\n          }\n        }\n      }\n\n      &__bottom {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        .statistics {\n          display: flex;\n          gap: 12px;\n\n          &__item {\n            padding: 4px 8px;\n            background-color: #fff;\n            border-radius: 10px;\n            border: 1px solid var(--light-grey);\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            &--icon {\n              width: 24px;\n              height: 24px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 9999px;\n\n              svg {\n                width: 16px;\n                height: 16px;\n\n                path {\n                  stroke: var(--accent-color-dark);\n                }\n              }\n            }\n\n            &--content {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n            }\n\n            &--value {\n              color: var(--accent-color-dark);\n              font-size: 16;\n              font-weight: bold;\n            }\n\n            &--title {\n              color: var(--dark-grey);\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .peer {\n      border: none;\n      border-bottom: 1px solid var(--light-grey);\n      border-radius: 0;\n      box-shadow: none;\n      margin-bottom: 10px;\n\n      &__left {\n        padding-top: 9px;\n        min-width: 40px;\n        min-height: 65px;\n\n        .ranking {\n          height: 40px;\n          font-size: 10px;\n\n          &--index {\n            font-size: 14px;\n          }\n        }\n      }\n\n      &__right {\n        padding: 0 0 12px 12px;\n\n        &__top {\n          .avatar {\n            min-width: 60px;\n            max-width: 60px;\n            height: 60px;\n          }\n\n          .info {\n            gap: 4px;\n            .name {\n              font-size: 16px;\n            }\n\n            .score {\n              font-size: 12px;\n\n              svg {\n                width: 16px;\n                height: 16px;\n              }\n              span {\n                display: none;\n              }\n            }\n\n            .inst-name {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-top-scholars": `VenueTopScholars_venue-top-scholars__veTJk`,
	"search-scholar-section": `VenueTopScholars_search-scholar-section__r7a0j`,
	"clear-search-button": `VenueTopScholars_clear-search-button__coNxN`,
	"peer": `VenueTopScholars_peer__tQBJ1`,
	"peer__left": `VenueTopScholars_peer__left__OCrsd`,
	"ranking": `VenueTopScholars_ranking__N+zWI`,
	"ranking--index": `VenueTopScholars_ranking--index__BjwwP`,
	"peer__right": `VenueTopScholars_peer__right__adeuw`,
	"peer__right__top": `VenueTopScholars_peer__right__top__+yxfa`,
	"avatar": `VenueTopScholars_avatar__NFUSI`,
	"photo": `VenueTopScholars_photo__AmZj6`,
	"check": `VenueTopScholars_check__pNaqZ`,
	"info": `VenueTopScholars_info__kJ9ke`,
	"info__top": `VenueTopScholars_info__top__6M011`,
	"name": `VenueTopScholars_name__tJZTu`,
	"score": `VenueTopScholars_score__buqZm`,
	"inst-name": `VenueTopScholars_inst-name__2zdds`,
	"position": `VenueTopScholars_position__Jv09Z`,
	"tags": `VenueTopScholars_tags__74-VA`,
	"peer__right__bottom": `VenueTopScholars_peer__right__bottom__uzAo8`,
	"statistics": `VenueTopScholars_statistics__GufRs`,
	"statistics__item": `VenueTopScholars_statistics__item__GA2Zo`,
	"statistics__item--icon": `VenueTopScholars_statistics__item--icon__zKr4L`,
	"statistics__item--content": `VenueTopScholars_statistics__item--content__1vWid`,
	"statistics__item--value": `VenueTopScholars_statistics__item--value__1ROln`,
	"statistics__item--title": `VenueTopScholars_statistics__item--title__L+uSU`
};
export default ___CSS_LOADER_EXPORT___;
